<template>
  <b-list-group class="mb-4">
    <template v-for="(lot, index) in lotsInProcess">
      <lot
        :lot="lot.lot"
        :lot_id="lot.lot_id"
        :fruit_id="lot.fruit_id"
        :product_id="lot.product_id"
        :product_name="lot.product_name"
        :product_code="lot.product_code"
        :net_kilograms_sum_in="lot.net_kilograms_sum_in"
        :net_kilograms_sum_out="lot.net_kilograms_sum_out"
      />
    </template>
  </b-list-group>
</template>

<script>
import Lot from "./Lot";

import { mapState, mapGetters } from "vuex";

export default {
  name: "LotList",
  components: {
    Lot
  },
  computed: {
    ...mapGetters("bagnoProcessModule", ["lotsInProcess"])
  },
  data() {
    return {};
  }
};
</script>

<style scoped></style>
